import { EmptyTool } from './EmptyTool';
import { Cursors, FRICTION, FRICTION_MOBILE, PAN, SCROLL_MAX, SCROLL_MIN, VELOCITY_MULTIPLIER } from './../../constants';
import { Movable, Scroller } from './../../utils/scroller';
import { defined } from './../../utils';
import { Point } from './../../math';
import { noMeta } from './noMeta';
import { macOS } from './../../utils/macOS';
export class ScrollerTool extends EmptyTool {
    constructor(toolService) {
        super(toolService);
        const diagram = this.toolService.diagram, canvas = diagram.canvas;
        const friction = diagram._mobileOS() ? FRICTION_MOBILE : FRICTION;
        const scroller = diagram.scroller = this.scroller = new Scroller(diagram.scrollable, {
            friction: friction,
            velocityMultiplier: VELOCITY_MULTIPLIER,
            mousewheelScrolling: false,
            zoom: false,
            scroll: this._move.bind(this)
        });
        if (canvas.translate) {
            this.movableCanvas = new Movable(canvas.element);
        }
        const virtualScroll = function (dimension, min, max) {
            dimension.makeVirtual();
            dimension.virtualSize(min || SCROLL_MIN, max || SCROLL_MAX);
        };
        virtualScroll(scroller.dimensions.x);
        virtualScroll(scroller.dimensions.y);
        scroller.disable();
    }
    tryActivate(_p, meta) {
        const toolService = this.toolService;
        const options = toolService.diagram.options.pannable;
        const macCmd = meta.metaKey && macOS();
        let enabled = meta.ctrlKey || macCmd;
        if (defined(options.key)) {
            if (!options.key || options.key === 'none') {
                enabled = noMeta(meta) && !defined(toolService.hoveredItem);
            }
            else {
                enabled = meta[options.key + 'Key'];
                enabled = enabled || (options.key === 'ctrl' && macCmd);
            }
        }
        return options !== false && enabled && !defined(toolService.hoveredAdorner) && !defined(toolService._hoveredConnector);
    }
    start() {
        this.scroller.enable();
    }
    move() {
    } // the tool itself should not handle the scrolling. Let kendo scroller take care of this part. Check _move
    _move(args) {
        const diagram = this.toolService.diagram, canvas = diagram.canvas;
        let scrollPos = new Point(args.scrollLeft, args.scrollTop);
        if (canvas.translate) {
            diagram._storePan(scrollPos.times(-1));
            this.movableCanvas.moveTo(scrollPos);
            canvas.translate(scrollPos.x, scrollPos.y);
        }
        else {
            scrollPos = scrollPos.plus(diagram._pan.times(-1));
        }
        diagram.trigger(PAN, { pan: scrollPos });
    }
    end() {
        this.scroller.disable();
    }
    getCursor() {
        return Cursors.move;
    }
}
